import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Cached } from '@lib/cache';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortBy } from 'lodash-es';
import { LoanApiService } from '../../services/loan-api.service';

@Injectable()
export class LookupResolverService implements Resolve<any> {
  private lookups: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(private loanApiService: LoanApiService) {}

  @Cached('lookups')
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.loanApiService.getLookups().pipe(
      map((items: any) => {
        const lookups = {};
        items.forEach((lookupItem) => {
          // Sort property state in alphabetical order
          if (lookupItem.key === 'propertyState') {
            lookups[lookupItem.key] = sortBy(lookupItem.value, 'description');
          } else {
            lookups[lookupItem.key] = lookupItem.value;
          }
        });
        this.lookups.next(lookups);
        return lookups;
      })
    );
  }
}
